import { IResourceComponentsProps, useExport, useTranslate } from "@refinedev/core";

import {
    BooleanField,
    CreateButton,
    DeleteButton,
    EditButton,
    ExportButton,
    List,
    useTable,
} from "@refinedev/antd";

// It is recommended to use explicit import as seen below to reduce bundle size.
// import { IconName } from "@ant-design/icons";
import * as Icons from "@ant-design/icons";

import { Space, Table } from "antd";
import React from "react";
import {IGroup} from '../../interfaces';

export const GroupList: React.FC<IResourceComponentsProps> = () => {
    const translate = useTranslate();
    const {tableProps} = useTable<IGroup>({
        resource: "groups",
        meta: {populate: '*'}
    });

    const {triggerExport, isLoading: exportLoading} = useExport<IGroup>();

    return (
            <List
                title={translate('pages.group.title', 'Groups')}
                headerProps={{
                    extra: [
                        <CreateButton/>,
                        <ExportButton
                            onClick={triggerExport}
                            loading={exportLoading}
                        />
                    ],
                }}
            >
                <Table size="small" {...tableProps} rowKey="id"
                       onRow={(record) => {
                           return {
                               onClick: () => {
                                   // console.log("group", record);
                               },
                           };
                       }}
                       sticky={true}

                       pagination={{
                           ...tableProps.pagination,
                           showSizeChanger: true,
                       }}>
                    {/*<Table.Column dataIndex="id" key="id" title="ID"/>*/}
                    <Table.Column
                        dataIndex="description"
                        key="description"
                        title={translate('pages.group.description', 'Description')}
                    />
                    <Table.Column
                        dataIndex="isAdmin"
                        key="isAdmin"
                        title={translate('pages.group.isAdmin', 'isAdmin')}
                        render={(value) => (
                            <BooleanField
                                value={value === true}
                                trueIcon={<Icons.CheckCircleOutlined/>}
                                falseIcon={<Icons.CloseCircleOutlined/>}
                            />
                        )}
                    />
                    <Table.Column
                        dataIndex="isUser"
                        key="isUser"
                        title={translate('pages.group.isUser', 'isUser')}
                        render={(value) => (
                            <BooleanField
                                value={value === true}
                                trueIcon={<Icons.CheckCircleOutlined/>}
                                falseIcon={<Icons.CloseCircleOutlined/>}
                            />
                        )}
                    />
                    <Table.Column
                        dataIndex="isOperator"
                        key="isOperator"
                        title={translate('pages.group.isOperator', 'isOperator')}
                        render={(value) => (
                            <BooleanField
                                value={value === true}
                                trueIcon={<Icons.CheckCircleOutlined/>}
                                falseIcon={<Icons.CloseCircleOutlined/>}
                            />
                        )}
                    />
                    <Table.Column<{ id: string }>
                        title={translate('pages.users.action', 'Action')}
                        dataIndex="actions"
                        key="actions"
                        render={(_, record) => (
                            <Space>
                                <EditButton
                                    hideText
                                    size="small"
                                    recordItemId={record.id}
                                />
                                <DeleteButton
                                    mutationMode={'undoable'}
                                    hideText
                                    size="small"
                                    recordItemId={record.id}
                                />
                            </Space>
                        )}
                    />

                </Table>
            </List>
    );
};
